var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainLayout',{attrs:{"fluid":""}},[_c('MerchantsTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }